import { render } from "./AlertDetails.vue?vue&type=template&id=3e566cc0&scoped=true"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"

import "./AlertDetails.vue?vue&type=style&index=0&id=3e566cc0&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e566cc0"]])

export default __exports__